(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["konanna-sober-popup"]) return;
  try {
    
  if (!customElements.get('konanna-sober-popup')) {
    customElements.define('konanna-sober-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.key = 'konanna-sober-october-2026-shown';
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.querySelector('.konanna-sober__close').addEventListener('click', () => this.dialog.close(), opts);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, opts);
        this.dialog.addEventListener('close', () => {
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, opts);
        this.querySelector('.konanna-sober__cta').addEventListener('click', () => this.remember(), opts);
        this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay) || 8000);
      }
      remember() {
        try { sessionStorage.setItem(this.key, '1'); } catch {}
      }
      tryOpen() {
        const now = Date.now();
        if (now < Date.parse(this.dataset.start) || now >= Date.parse(this.dataset.end)) return;
        try { if (sessionStorage.getItem(this.key)) return; } catch {}
        const active = document.activeElement;
        const isTyping = active && (active.matches('input, textarea, select') || active.isContentEditable);
        const otherDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden]), cart-drawer.active, #shopify-pc__banner')).some(element => element !== this.dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
        if (document.hidden || isTyping || otherDialog) {
          this.timer = setTimeout(() => this.tryOpen(), 1500);
          return;
        }
        if (window.Shopify?.designMode) return;
        this.previousFocus = active;
        this.dialog.showModal();
        this.remember();
        this.expiryTimer = setTimeout(() => this.dialog.close(), Math.min(Date.parse(this.dataset.end) - now, 2147483647));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.expiryTimer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
